import React, { useState, useRef, useEffect } from "react";

import "./DropdownMenu.css";

export function DropdownMenu({ trigger, items, alignLeft = false, maxHeight = null }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const debounceRef = useRef(null);
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    // Detect if this is a touch device
    setIsTouchDevice('ontouchstart' in window || navigator.maxTouchPoints > 0);
  }, []);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleMouseEnter = () => {
    // Skip mouse events on touch devices
    if (isTouchDevice) return;
    
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    // Skip mouse events on touch devices
    if (isTouchDevice) return;
    
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      setIsOpen(false);
    }, 500);
  };

  return (
    <div
      ref={dropdownRef}
      onMouseEnter={!isTouchDevice ? handleMouseEnter : undefined}
      onMouseLeave={!isTouchDevice ? handleMouseLeave : undefined}
    >
      <div className={`dropdown ${alignLeft ? 'dropdown-left' : 'dropdown-right'}`} onClick={toggleDropdown}>
        {trigger}
      </div>
      {isOpen && (
        <div 
          className={`dropdown-menu ${isOpen ? "open" : ""} ${alignLeft ? "align-left" : ""}`}
          style={maxHeight ? { maxHeight, overflowY: 'auto' } : {}}
        >
        {items.map((item, index) => {
          if (item.type === "divider") {
            return <div key={index} className="dropdown-divider"></div>;
          }
          return (
            <div key={index} className={"dropdown-item"}>
              {item.label}
            </div>
          );
        })}
      </div>
      )}
    </div>
  );
}
